import React from 'react'
import PropTypes from 'prop-types'

import FormContext from '../context'

function FormInput (props) {
  return (
    <FormContext.Consumer>
    {(form) => {
      return (
        <div className={props.className}>
          <input
            {...props}
            name={props.name}
            value={form.inputs[props.name]}
            onChange={form.onChange}
            className="form-control"
            type={props.type}
           />
        </div>
      )
    }}
  </FormContext.Consumer>
  )
}

FormInput.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.string
}

export default FormInput
